import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Product = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;
  const userId = user?.user_id;

  const [hoveredRow, setHoveredRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = (id) => {
    setHoveredRow(id);
    localStorage.removeItem("user_id");
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };

  useEffect(() => {
    // `!== null` also let `undefined` through, firing an empty toast.
    if (location.state && is_alert === false) {
      toast.success(location.state);
      is_alert = true;
    }
    window.history.replaceState({}, "");
  }, []);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [monthFilter, setMonthFilter] = useState("");
  const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  // A network/CORS failure carries no `err.response`, so reading it directly
  // threw inside the catch block and the user saw nothing at all. The API
  // returns its text on `message`; `msg` is kept for older endpoints.
  const handleApiError = (err, fallback = "Something went wrong.") => {
    const status = err?.response?.status;
    const message = err?.response?.data?.message || err?.response?.data?.msg;
    const AUTH_MSG = ["Token not found.", "Invalid token.", "Unauthorized."];

    if (status === 401 || status === 403 || AUTH_MSG.includes(message)) {
      localStorage.clear();
      Navigate("/admin/login");
      return;
    }

    if (!err?.response) {
      toast.error("No response from server. Please check your connection.");
      return;
    }

    toast.error(message || fallback);
  };

  const ProductData = () => {
    const limit = 10;
    const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

    let apiUrl = "";

    if (userType === "admin") {
      apiUrl = `${process.env.REACT_APP_URL}/admin/products?page=${page}&search=${search}${monthQuery}`;
    } else if (userType === "supplier") {
      apiUrl = `${process.env.REACT_APP_URL}/admin/supplier_products/supplier/${userId}?page=${page}&limit=${limit}&search=${search}${monthQuery}`;
    }

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setTotalPage(res?.data?.data?.pagination?.totalPages || 0);
        setData(res?.data?.data?.products || []);
      })
      .catch((err) => handleApiError(err, "Failed to load products"));
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .put(
            `${process.env.REACT_APP_URL}/admin/products/${id}`,
            {
              is_active: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              ProductData();
            }
          })
          .catch((err) => handleApiError(err, "Failed to update status"));
      }
    });
  };

  const HandleApproved = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .put(
            `${process.env.REACT_APP_URL}/admin/products/${id}`,
            {
              approved: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              ProductData();
            }
          })
          .catch((err) => handleApiError(err, "Failed to update approval"));
      }
    });
  };

  const HandleDelete = (e) => {
    Swal.fire({
      title: "Do you want to Delete this Record?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#DC3741",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .delete(`${process.env.REACT_APP_URL}/admin/products/${e}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              Swal.fire({
                title: "Deleted Sucessfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              ProductData();
            }
          })
          .catch((err) => handleApiError(err, "Failed to delete product"));
      }
    });
  };

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "products.xlsx");
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  useEffect(() => {
    ProductData();
  }, [page, search, monthFilter]);

  const IMG_BASE = process.env.REACT_APP_IMAGE_URL;
  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const parseImages = (item) => {
    try {
      return item?.product_image ? JSON.parse(item.product_image) : [];
    } catch {
      return [];
    }
  };

  const isAdmin = userType === "admin" || userType === "subadmin";
  const isSupplier = userType === "supplier";

  const [dense, setDense] = useState(false);
  const [sortDir, setSortDir] = useState("");

  let displayData = [...(data || [])];
  if (sortDir) {
    displayData.sort((a, b) => {
      const av = (a?.title || "").toLowerCase();
      const bv = (b?.title || "").toLowerCase();
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }

  const ActiveToggle = ({ item }) => (
    <button type="button" className={`al-toggle ${item.is_active ? "is-on" : ""}`}
      title={item.is_active ? "Deactivate" : "Activate"}
      onClick={() => HandleActiveDeactive(item.product_id, item.is_active)}>
      <span className="al-toggle__knob" />
    </button>
  );
  const ApprovedToggle = ({ item }) => (
    <button type="button" className={`al-toggle ${item.approved ? "is-on" : ""}`}
      title={item.approved ? "Un-approve" : "Approve"}
      onClick={() => HandleApproved(item.product_id, item.approved)}>
      <span className="al-toggle__knob" />
    </button>
  );
  const StatusCell = ({ item }) => (isSupplier ? <ApprovedToggle item={item} /> : <ActiveToggle item={item} />);

  const PicIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
  );
  const imgTileBase = {
    display: "inline-flex", width: 26, height: 26, borderRadius: 7,
    alignItems: "center", justifyContent: "center", border: 0, padding: 0, cursor: "pointer",
  };
  const cleanImgPath = (p) => String(p ?? "").trim().replace(/["[\]]/g, "");

  // Real thumbnail with a placeholder-icon fallback: the icon tile is always
  // rendered underneath, and the <img> removes itself if the file 404s or the
  // path is empty — so a product with no usable image looks the same as before.
  const Thumb = ({ src, alt, onClick }) => {
    const t = TINTS[0];
    return (
      <button type="button" title="View image" onClick={onClick}
        style={{ ...imgTileBase, position: "relative", overflow: "hidden", background: t.bg, color: t.color }}>
        <PicIcon />
        {src && (
          <img src={src} alt={alt} loading="lazy"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
        )}
      </button>
    );
  };

  const ImageStack = ({ item }) => {
    const imgs = parseImages(item).map(cleanImgPath).filter(Boolean);
    if (!imgs.length) {
      const t = TINTS[0];
      return (
        <span style={{ ...imgTileBase, background: t.bg, color: t.color, cursor: "default" }}>
          <PicIcon />
        </span>
      );
    }
    const shown = imgs.slice(0, 3);
    const extra = imgs.length - shown.length;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {shown.map((image, i) => (
          <Thumb key={i} src={`${IMG_BASE}${image}`} alt={`${item.title || "Product"} image ${i + 1}`}
            onClick={() => { setSelectedImage(`${IMG_BASE}${image}`); setShowImagesModal(true); }} />
        ))}
        {extra > 0 && (
          <button type="button" title="View images"
            style={{ fontSize: 11, fontWeight: 700, color: "var(--color-text-tertiary)", background: "transparent", border: 0, cursor: "pointer", padding: 0 }}
            onClick={() => { setSelectedImage(`${IMG_BASE}${imgs[3]}`); setShowImagesModal(true); }}>
            +{extra}
          </button>
        )}
      </div>
    );
  };

  const RowActions = ({ item }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() => Navigate("/admin/product/show", { state: { item: item } })}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
      <button type="button" className="al-act al-act--primary" title="Edit"
        onClick={() => Navigate("/admin/product/edit", { state: { id: item?.product_id, title: item?.title, status: item?.approved } })}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>
      </button>
      <button type="button" className="al-act al-act--danger" title="Delete"
        onClick={() => HandleDelete(item?.product_id)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "1.6fr 1fr .7fr 1.6fr 120px 1fr .9fr 118px" };
  const strip = (html = "") => (html || "").replace(/<[^>]+>/g, "");

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Products</h1>
          <p className="al-sub">Catalog of products listed on the marketplace.</p>
        </div>
        <div className="al-head__actions">
          {userType === "admin" && (
            <button type="button" className="al-btn" onClick={exportToExcel}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Export
            </button>
          )}
          <button type="button" className="al-btn al-btn--primary" onClick={() => Navigate("/admin/product/add")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Product
          </button>
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search products by title…"
              onKeyDown={(e) => e.key === "Enter" && search !== "" && ProductData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}>
              <option value="">Select Month</option>
              <option value="All">All</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobileView ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 1120, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th al-th--sort" onClick={() => setSortDir((d) => (d === "asc" ? "desc" : d === "desc" ? "" : "asc"))}>
                  Title
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: sortDir ? 1 : 0.45, transform: sortDir === "desc" ? "rotate(180deg)" : "none" }}><polyline points="18 15 12 9 6 15"/></svg>
                </span>
                <span className="al-th">Product Category</span>
                <span className="al-th">Product Size</span>
                <span className="al-th">Description</span>
                <span className="al-th">Image</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th">{isSupplier ? "Approved" : "Is Active"}</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {displayData && displayData.length > 0 ? (
                displayData.map((item, index) => {
                  const ct = tint(item?.categoryInfo?.product_category_name);
                  const own = userId === String(item.user_id);
                  return (
                    <div className="al-row" style={{ ...GRID, background: own ? "var(--color-primary-weak)" : undefined }} key={index}
                      onMouseEnter={() => handleMouseEnter(item.user_id)} onMouseLeave={handleMouseLeave}>
                      <span className="al-name">{item.title}</span>
                      <span>
                        {item?.categoryInfo?.product_category_name ? (
                          <span className="al-pill" style={{ background: ct.bg, color: ct.color }}>{item.categoryInfo.product_category_name}</span>
                        ) : <span className="al-muted">—</span>}
                      </span>
                      <span className="al-muted al-ellipsis" title={item?.size}>{item?.size || "—"}</span>
                      <span className="al-muted al-ellipsis" title={strip(item?.description)}>{strip(item?.description) || "—"}</span>
                      <ImageStack item={item} />
                      <span className="al-mono al-muted">{formatDate(item.created_at)}</span>
                      <span><StatusCell item={item} /></span>
                      <RowActions item={item} />
                    </div>
                  );
                })
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                  </div>
                  <p className="al-empty__title">No Products Found</p>
                  <p className="al-empty__text">Try a different search or add a product.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {displayData && displayData.length > 0 ? (
              displayData.map((item, index) => {
                const ct = tint(item?.categoryInfo?.product_category_name);
                return (
                  <div className="al-mcard" key={index}>
                    <div className="al-mcard__top">
                      <ImageStack item={item} />
                      <div className="al-name" style={{ flex: 1 }}>{item.title}</div>
                      <StatusCell item={item} />
                    </div>
                    <div className="al-mrow">
                      <span className="al-muted">Category</span>
                      {item?.categoryInfo?.product_category_name ? (
                        <span className="al-pill" style={{ background: ct.bg, color: ct.color }}>{item.categoryInfo.product_category_name}</span>
                      ) : <span className="al-muted">—</span>}
                    </div>
                    <div className="al-mrow">
                      <span className="al-muted">Size</span>
                      <span className="al-muted">{item?.size || "—"}</span>
                    </div>
                    <div className="al-mrow">
                      <span className="al-muted">Date</span>
                      <span className="al-mono al-muted">{formatDate(item.created_at)}</span>
                    </div>
                    <div className="al-mactions"><RowActions item={item} /></div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Products Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{displayData?.length || 0}</strong> products</span>
          {data && data.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>

      {showImagesModal && (
        <div className="al-modal" onClick={() => setShowImagesModal(false)}>
          <div className="al-modal__scrim" />
          <div className="al-modal__box" onClick={(e) => e.stopPropagation()} style={{ width: "min(420px,92vw)" }}>
            <div className="al-modal__head">
              <h3 className="al-modal__title">Product Image</h3>
              <button type="button" className="al-act" onClick={() => setShowImagesModal(false)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding: 20, display: "flex", justifyContent: "center" }}>
              {selectedImage ? (
                <img src={selectedImage} alt="Preview" style={{ maxWidth: "100%", maxHeight: 340, borderRadius: 12 }} />
              ) : (
                <p className="al-muted">No image available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Product;
